<template>
  <div class="position-absolute" :style="{ 'top': top + 'px', 'right': right + 'px', 'z-index': zIndex }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BtnPosition',
  props: {
    // 距离上
    top: {
      type: Number,
      default: 8
    },
    // 距离右
    right: {
      type: Number,
      default: 10
    },
    zIndex: {
      type: Number,
      default: 99
    }
  },
  data() {
    return {}
  }
}
</script>
